import React from 'react';
import { Link } from 'react-router-dom';
import BlurText from './ui/BlurText';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-section brand-section">
            <div className="footer-logo">
              <img src="/images/nexawave-logo.png" alt="Nexawave Logo" className="footer-logo-img" />
              <p>Premium refurbished technology at unbeatable prices. Quality guaranteed, warranty included.</p>
            </div>
            {/* Social Media Links */}
            <div className="social-links">
              <a 
                href="https://www.instagram.com/nexawaveofficial/" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Follow us on Instagram"
                className="social-link instagram"
              >
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204 0.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                </svg>
              </a>
              <a 
                href="https://www.facebook.com/profile.php?id=61577081417375&sk=reels_tab" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Follow us on Facebook"
                className="social-link facebook"
              >
                <svg viewBox="0 0 24 24" fill="currentColor"> 
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                </svg>
              </a>
              <a 
                href="https://www.youtube.com/@nexawavetechnology-u6o" 
                target="_blank" 
                rel="noopener noreferrer"
                aria-label="Follow us on YouTube"
                className="social-link youtube"
              >
                <svg viewBox="0 0 24 24" fill="currentColor"> 
                  <path d="M21.5,7.3c-0.2-0.7-0.8-1.2-1.5-1.4C18.4,5.4,12,5.4,12,5.4S5.6,5.4,3.9,5.9C3.2,6.1,2.6,6.6,2.4,7.3C1.9,8.9,1.9,12,1.9,12S1.9,15.1,2.4,16.7c0.2,0.7,0.8,1.2,1.5,1.4c1.7,0.5,8.1,0.5,8.1,0.5s6.4,0,8.1-0.5c0.7-0.2,1.3-0.7,1.5-1.4c0.5-1.6,0.5-4.7,0.5-4.7S22,8.9,21.5,7.3z M9.9,14.6V9.4l4.2,2.6L9.9,14.6z"/>
                </svg>
              </a>
            </div>
          </div>
          {/* Footer Links Grid - 2x2 on mobile */}
          <div className="footer-links-grid">
            {/* Shop */}
            <div className="footer-section">
              <h4>Shop</h4>
              <ul>
                <li><Link to="/laptops">Laptops</Link></li>
                <li><Link to="/desktops">Desktops</Link></li>
                <li><Link to="/monitors">Monitors</Link></li>
                <li><Link to="/mini-pcs">Mini PCs</Link></li>
                <li><Link to="/all-in-one">All in One</Link></li>
                <li><Link to="/accessories">Accessories</Link></li>
              </ul>
            </div>
            {/* Categories */}
            <div className="footer-section">
              <h4>Categories</h4>
              <ul>
                <li><Link to="/laptops?subcategory=Student">Student</Link></li>
                <li><Link to="/laptops?subcategory=Office%20Use">Office Use</Link></li>
                <li><Link to="/laptops?subcategory=Business">Business</Link></li>
                <li><Link to="/laptops?subcategory=Gaming">Gaming</Link></li>
                <li><Link to="/laptops?subcategory=Creative">Creative</Link></li>
                <li><Link to="/laptops?subcategory=Accessories">Accessories</Link></li>
              </ul>
            </div>
            {/* Support */}
            <div className="footer-section">
              <h4>Support</h4>
              <ul>
                <li><Link to="/warranty">Warranty</Link></li>
                <li><Link to="/shipping">Shipping Info</Link></li>
                <li><Link to="/contact-us">Contact Us</Link></li>
                <li><Link to="/terms">Terms & Conditions</Link></li>
                <li><Link to="/refund-policy">Cancellation & Refund Policy</Link></li>
              </ul>
            </div>
            {/* Company */}
            <div className="footer-section">
              <h4>Company</h4>
              <ul>
                <li><Link to="/about-us">About Us</Link></li>
                <li><Link to="/store">Store Location</Link></li>
                <li><Link to="/privacy">Privacy Policy</Link></li>
                <li><Link to="/terms">Terms of Service</Link></li>
              </ul>
            </div>
          </div>
        </div>
        {/* Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; 2024 Nexawave Technology Software Pvt Ltd. All rights reserved.</p>
          </div>
          <div className="footer-developer">
            <a 
              href="https://techzetastudio.com" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <BlurText 
                text="Website developed by Techzetastudio.com | Syed Taha - 8971872871" 
                textColor="var(--primary-color)"
                fontSize="0.85rem"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
